import toString from 'lodash/toString';
import _toNumber from 'lodash/toNumber';
import { removeTrailingZero } from './removeTrailingZero';
/**
 * It takes a number and returns a string with commas in the right places.
 * @param {any} value - any - The value to be formatted.
 * @param {number} [precision] - number of decimal places to round to
 * @returns A function that takes two parameters, value and precision.
 */

interface OptionsFormatter {
	precision?: number;
	isRemoveZero?: boolean;
}
export const formatNumber = (value: any, precision?: number | OptionsFormatter) => {
	value = toString(value);

	let fixed: undefined | number;
	let isRemoveZero = false;
	if (typeof precision === 'number') {
		fixed = precision;
	} else {
		fixed = precision?.precision;
		isRemoveZero = Boolean(precision?.isRemoveZero);
	}
	if (fixed) {
		value = toString(_toNumber(value).toFixed(fixed));
	}

	let result = value;
	if (value.indexOf('e') !== -1) {
		const exponent = parseInt(value.split('-')[1], 10);
		result = _toNumber(value).toFixed(exponent);
	}
	const stringFormat = `${result}`;
	const x = stringFormat.split('.');
	let x1 = x[0];
	const x2 = x.length > 1 ? `.${x[1]}` : '';
	const regex = /(\d+)(\d{3})/;
	while (regex.test(x1)) {
		x1 = x1.replace(regex, '$1,$2');
	}
	const data = isRemoveZero ? removeTrailingZero(x1 + x2) : x1 + x2;
	return data;
};